import React from "react";
import card1 from "assets/Images/bg/hero_card1.jpg";
import card2 from "assets/Images/bg/hero_card2.jpg";
// css
import "./Hero.css";

// HERO COMPONENT HOME PAGE
const Hero = () => {
  return (
    <>
      <section className="hero">
        {/* <div className="hero-contain">
        <div className="hero_text">
          <h1>Book your perfect yacht vacation</h1>
          <p>
            More than 40,000 private yacht rentals and bareboat charters near me
            for your next boating trip.
          </p>
        </div>
      </div> */}
        {/* <SearchDropdown /> */}
        <div className="cs_container">
          <div className="hero_new_content">
            <h1>Book & Make your Joyful <br /> Experience </h1>
            <p>More than 40,000 private yacht rentals and bareboat charters near me for your next boating trip. </p>
          </div>
    
        <div className="row hero_new_cards_row">
          <div className="hero_card hero_card1">
            <img src={card1} alt="" />
            <h3>All-inclusive</h3>
            <p>Get the best pack which fits your needs wisely made for <br/> you </p>
            <button>Show All Inclusive Offers</button>
          </div>
          <div className="hero_card hero_card2">
          <img src={card2} alt="" />
            <h3>Boat Booking</h3>
            <p>Book your perfect yacht vacation</p>
            <button>
              <svg width="48" height="26" viewBox="0 0 48 26" fill="none">
                <path d="M47.7806 11.1249C47.5536 10.8008 47.1828 10.6077 46.7872 10.6077H36.9558C34.1995 8.09505 30.5688 6.65613 26.7722 6.65613H19.0814C19.7311 6.04036 20.6052 5.67699 21.5541 5.67699H26.7329C27.2764 5.67699 27.7537 5.31544 27.9005 4.7921C28.0475 4.26887 27.8284 3.71169 27.3643 3.42861C23.686 1.18568 19.4646 0 15.1563 0H10.2704C7.65261 0 5.28755 1.65093 4.38506 4.10829C4.2485 4.48027 4.30223 4.89555 4.52915 5.2206C4.75595 5.54564 5.12733 5.73921 5.52369 5.73921H8.45478L3.46596 16.56C2.46379 17.1462 1.48077 17.773 0.519949 18.4422C0.194177 18.6689 0 19.0408 0 19.4375V23.8593C0 24.5291 0.542993 25.0722 1.21285 25.0722H29.5948C33.6189 25.0722 37.4884 23.852 40.7847 21.5439C44.0809 19.2357 46.5508 16.0169 47.9269 12.2354C48.0621 11.8635 48.0077 11.4491 47.7806 11.1249ZM29.5948 22.6465H2.4257V20.0767C9.26182 15.4669 17.2191 13.0335 25.4793 13.0335H44.9571C42.1246 18.8483 36.1556 22.6465 29.5948 22.6465ZM11.4508 5.03418C11.6238 4.65868 11.5938 4.22084 11.3708 3.87251C11.1479 3.5243 10.7628 3.31363 10.3494 3.31363H7.81767C8.49396 2.75354 9.35702 2.42582 10.2704 2.42582H15.1563C17.1639 2.42582 19.1507 2.71303 21.0589 3.27118C18.6045 3.46863 16.5249 5.12405 15.7953 7.51519C15.6831 7.8828 15.7519 8.28183 15.9806 8.59074C16.2094 8.89978 16.5709 9.08195 16.9554 9.08195H26.7722C28.901 9.08195 30.9672 9.62142 32.7945 10.6078H25.4795C19.026 10.6078 12.7474 12.0107 6.99148 14.7069L11.4508 5.03418Z" fill="#1A4D6D" />
                <path d="M24.4152 16.4102H20.8222C20.1524 16.4102 19.6094 16.9533 19.6094 17.623C19.6094 18.2927 20.1524 18.8359 20.8222 18.8359H24.4152C25.085 18.8359 25.628 18.2927 25.628 17.623C25.628 16.9533 25.085 16.4102 24.4152 16.4102Z" fill="#1A4D6D" />
                <path d="M34.6886 16.4102H31.0957C30.4258 16.4102 29.8828 16.9533 29.8828 17.623C29.8828 18.2927 30.4258 18.8359 31.0957 18.8359H34.6886C35.3585 18.8359 35.9015 18.2927 35.9015 17.623C35.9015 16.9533 35.3583 16.4102 34.6886 16.4102Z" fill="#1A4D6D" />
              </svg>
              Book now</button>
          </div>
        </div>
        </div>
      </section>
    </>
  );
};

export default Hero;
